<template>
	<div class="main">
		<!-- 头部 -->
    <Header :index="2"></Header>
		<!-- 面包屑导航 -->
		<div class="sec_top_position">
			<div class="curPosition">
				<img src="@/assets/img/fruit-transfer/icon14.png">
				您所在的位置：<a :href="homeHref">首页</a> &gt;
				<a href="#">互动交流</a>
			</div>
		</div>
		<el-form  ref="sqForm" :model="sqForm" label-width="80px">

		</el-form>
		<Footer></Footer>
	</div>
</template>

<script>
	import setRemPc from '@/api/setrem'
	import Header from '@/views/platform/components/header.vue'
	import Footer from '@/views/platform/components/footer.vue'
	export default {
		components:{
			Header,
			Footer
		},
		data() {
			return {
				homeHref: process.env.VUE_APP_NAV_BASE_URL + 'ch00108/',
				lx:'',//诉求类型
				sqForm:{

				}
			};
		},
		mounted() {},
		created(){
			// 实例创建完成后被立即调用rem换算方法,解决内容闪现问题
			setRemPc();
			window.addEventListener('resize', setRemPc);//浏览器窗口大小改变时调用rem换算方法
		},
		methods: {

		}
	};
</script>

<style lang="scss" scoped>
	@import url('~@/assets/css/breadnav.css');
	.main {
		width: 100%;
		height: 100%;
		background-color: #F5F5F5;

	}
</style>
